import {
  useGetUniversalSearchJobsQuery,
  useGetUniversalSearchTalentQuery,
} from "../api";
import { useDebouncedUniversalSearchPhrase } from "../universal-search-slice";

type UseUniversalSearchQueryArg = {
  options?: {
    skip?: boolean;
  };
  canAccessPeople: boolean;
};

export const useUniversalSearchQuery = ({
  options,
  canAccessPeople,
}: UseUniversalSearchQueryArg) => {
  const search = useDebouncedUniversalSearchPhrase();
  const { data: jobResults } = useGetUniversalSearchJobsQuery(
    { search },
    options,
  );
  const { data: talentResults } = useGetUniversalSearchTalentQuery(
    { search },
    { skip: !canAccessPeople || options?.skip },
  );

  return {
    data: { talentResults, jobResults },
  };
};
